import template from './contract.all.html';
import controller from './contract.all.controller';
import './contract.all.scss';

let contractallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default contractallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/all/contract.all.component.js